import { Form } from 'factorial-form'

class IncidenceNote extends Form {
  constructor(values: {}) {
    super(values, {
      content: 'string',
    })
  }
}

export default IncidenceNote
